import { ArAgingSummaryResponse } from "@common/types/reports/types";
import { ArAgingSummaryViewRow } from "./arAgingSummaryViewTypes";

/**
 * Converts an ArAgingSummaryResponse into a flat row model for the ViewTable
 * runtime. No nesting; the synthetic Total row (totalsByBucket / grandTotal)
 * is appended as the last sibling, mirroring Expense by Vendor's Total row.
 */
export function buildArAgingSummaryRows(
    report: ArAgingSummaryResponse,
): ArAgingSummaryViewRow[] {
    const rows: ArAgingSummaryViewRow[] = report.rows.map((row) => ({
        id: `customer:${row.customerId ?? row.customerName}`,
        customerId: row.customerId,
        customerName: row.customerName,
        amountsByBucket: row.amountsByBucket,
        total: row.total,
        isSummary: false,
    }));

    rows.push({
        id: "total:ar-aging-summary",
        customerId: null,
        customerName: "Total",
        amountsByBucket: report.totalsByBucket,
        total: report.grandTotal,
        isSummary: true,
    });

    return rows;
}
